import React from "react";
import Plot from "react-plotly.js";

const DistributionPlot = ({ data }) => {

  const plotData = [
    {
      x: data,
      type: "histogram",
      marker: {
        color: "rgba(100, 200, 102, 0.7)",
        line: {
          color: "rgba(100, 200, 102, 1)",
          width: 1,
        },
      },
    },
  ];

  const layout = {
    title: {
      text: "<b>Category Count Histogram</b>",
      font: {
        size: 18,
      },
    },
    xaxis: {
      title: "Categories",
    },
    yaxis: {
      title: "Count",
    },
    bargap: 0.2,
    autosize: true,
    margin: { l: 40, r: 30, b: 50, t: 50 }
  };

  return (
    <Plot
        data={plotData}
        layout={layout}
        useResizeHandler={true}
        style={{ width: "80%", height: "100%" }}
        config={{ responsive: true }}
      />
  );
};

export default DistributionPlot;
